// The colour the owner played.
import { ownerColour } from '../classify.ts';
import { oneOf, type FilterCriterion } from '../criterion.ts';
import { GAME_COLOURS } from '@chess/api-model';

export const colour: FilterCriterion<'colour'> = {
  key: 'colour',
  query: 'colour',
  many: true,
  parse: oneOf(GAME_COLOURS),
  format: (v) => v,
  matches: (game, v) => ownerColour(game) === v,
  control: { kind: 'choice', order: 20, label: 'Colour', options: [['white', 'White'], ['black', 'Black']] },
};
